const regraPadraoVazia = () => ({
  tipo: 'PERIODO',
  nome: '',
  status: 'ATIVO',
  motivoDesativacao: '',
  dataInicio: new Date(),
  dataFim: null,
  dias: {
    segunda: 1,
    terca: 1,
    quarta: 1,
    quinta: 1,
    sexta: 1,
    sabado: 1,
    domingo: 1
  },
  datas: [],
  valorServico: 0,
  valorADT: 0,
  valorCHD: 0,
  valorINF: 0,
  valorJVM: 0,
  valorIDSO: 0
})

const parseDataLocal = (valor) => {
  if (!valor) return null
  if (valor instanceof Date) return valor
  const str = String(valor).slice(0, 10)
  const [y, m, d] = str.split('-').map(Number)
  if (!y || !m || !d) return null
  return new Date(y, m - 1, d)
}

const mapearRegrasTarifario = (fornecedor) => {
  const regrasApi = Array.isArray(fornecedor?.regras) ? fornecedor.regras : []
  if (regrasApi.length === 0) {
    return [{
      ...regraPadraoVazia(),
      valorServico: fornecedor?.valor_servico ?? 0,
      valorADT: fornecedor?.valor_adt ?? 0,
      valorCHD: fornecedor?.valor_chd ?? 0,
      valorINF: fornecedor?.valor_inf ?? 0,
      valorJVM: fornecedor?.valor_jvm ?? 0,
      valorIDSO: fornecedor?.valor_idso ?? 0,
      dataInicio: parseDataLocal(fornecedor?.tar_data_inicio) || new Date(),
      dataFim: parseDataLocal(fornecedor?.tar_data_termino)
    }]
  }

  return regrasApi.map((regra) => {
    const dias = {
      segunda: Number(regra.segunda) || 0,
      terca: Number(regra.terca) || 0,
      quarta: Number(regra.quarta) || 0,
      quinta: Number(regra.quinta) || 0,
      sexta: Number(regra.sexta) || 0,
      sabado: Number(regra.sabado) || 0,
      domingo: Number(regra.domingo) || 0
    }
    const algumDia = Object.values(dias).some((v) => v === 1)
    return {
      id: regra.id,
      tipo: 'PERIODO',
      nome: regra.nome || '',
      status: regra.status || 'ATIVO',
      motivoDesativacao: regra.motivo_desativacao || '',
      dataInicio: parseDataLocal(regra.data_inicio) || parseDataLocal(fornecedor?.tar_data_inicio) || new Date(),
      dataFim: parseDataLocal(regra.data_termino) || parseDataLocal(fornecedor?.tar_data_termino),
      dias: algumDia ? dias : {
        segunda: 1, terca: 1, quarta: 1, quinta: 1, sexta: 1, sabado: 1, domingo: 1
      },
      datas: [],
      valorServico: regra.valor_servico ?? 0,
      valorADT: regra.valor_adt ?? 0,
      valorCHD: regra.valor_chd ?? 0,
      valorINF: regra.valor_inf ?? 0,
      valorJVM: regra.valor_jvm ?? 0,
      valorIDSO: regra.valor_idso ?? 0
    }
  })
}

const INITIAL_STATE = {
  parceiroFornecedor: [],
  statusTipos: [],
  tarifarios: [],
  editarParceiro: {},
  dadosParceiro: {
    enderecoSim: true,
    enderecoNao: false
  },
  parceiro: {
    data: []
  },
  enderecoCobranca: {
    data: []
  },
  enderecoPadrao: {
    data: []
  },
  dadosEmpresa: {},
  dadosFinanceiros: {},
  dadosContatos: {},
  dadosSocios: [],
  dadosDocumentos: {},
  dadosBancarios: {},
  fornecedores: [],
  socios: [],
  listSocios: [],
  agentes: [],
  usuarios: [],
  dadosUsuario: {},
  mundo: {
    estados: [],
    cidades: [],
    bairros: [],
    estadosCobranca: [],
    cidadesCobranca: [],
    bairrosCobranca: []
  },
  errors: [],
  referenciasBancarias: [],
  referenciaBancaria: null,
  parceiroId: 0,
  usuariosParceiros: {
    usuarios: {
      data: []
    }
  },
  usuarioParceiro: null,
  referenciasComerciais: [],
  referenciaComercial: null,
  parceiroId: 0,
  cliente: [],
  tipos: {},

  // GUIAS
  guiasSelectOptions: [],
  guiasTourDateSelectOptions: [],
  // { "2026-08-31": [par_id, ...] } — quem avisou pelo app que nao trabalha no dia
  guiasBloqueiosDatas: {},
  passeiosGuiaDateSelectOptions: [],

  // FORNECEDOR
  fornecedoresSelectOptions: [],
  dadosPromotor: {},
  dadosHotel: {},
  dadosContatos: {},

  dadosAgenciaTurismo: {},
  dadosOperadoraTurismo: {},
  dadosFinanceiro: {
    dataArray: [
      {
        data: null
      }
    ],
    dias: [],
    // pagamentosIds: [],
    pagamentosTiposIds: [],
    limiteCredito: 0,
    metaReservasMes: '',
    metaPorSegmento: true,
    vencimento: 0,
    gerarFaturaPorAgente: false,
    faturaPorAgenteParcial: false,
    agentesFaturaIndividualIds: [],
    categoriaFinanceiraPagamentoId: null,
    categoriaFinanceiraRecebimentoId: null,
    fechamentoPorSegmento: false,
    limitesPorSegmento: true,
  },
  parceiroTarifarios: [],
  parceiroTarifario: null,
  parceiroTarifarioInput: {
    servico: { value: 0, label: 'Selecione a atividade' },
    parceiro: { value: 0, label: 'Selecione o Parceiro' }
  },
  segmentoSelecionado: { value: '', label: '' },
  clienteDefaultOptions: [],
  path: '/parceiro',
  financeiroDisableDia: false,
  financeiroDisableData: false
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case 'PARCEIRO_FORNECEDOR':
      return { ...state, parceiroFornecedor: action.payload }
    case 'PARCEIRO_SEGMENTO_SELECIONADO':
      return { ...state, segmentoSelecionado: action.payload }
    case 'PARCEIRO_STATUS':
      return { ...state, statusTipos: action.payload }

    case 'SET_DADOS_PARCEIRO':
      const parceiro = { ...state.dadosParceiro }
      parceiro[action.payload.campo] = action.payload.value
      return { ...state, dadosParceiro: parceiro }

    case 'PARCEIRO_FETCHED': {

      const copyContatos = { ...state.dadosContatos }

      if (action.payload.parceiro.contato) {
        for (const contato of action.payload.parceiro.contato) {
          if (contato.id_contatos_tipos == 1) {
            copyContatos['whatsapp'] = contato.whatsapp
            copyContatos['telefoneFixo'] = contato.contato
            copyContatos['responsavelReserva'] = contato.responsavel
            copyContatos['telefoneEmergencia'] = contato.contato_emergencia
            copyContatos['horario'] = contato.descricao
            copyContatos['id_responsavel'] = contato.id
          } else if (contato.id_contatos_tipos == 2) {
            copyContatos['contatoGerente'] = contato.contato
            copyContatos['gerente'] = contato.descricao
            copyContatos['proprietario'] = contato.responsavel
            copyContatos['email'] = contato.email
            copyContatos['site'] = contato.site
            copyContatos['instagram'] = contato.instagram
            copyContatos['id_proprietario'] = contato.id
          }
        }
      }

      const copySocios = [...state.listSocios]

      if (action.payload.socios.length > 0) {
        for (const socios of action.payload.socios) {

          const socio = {}
          const endereco = {
            cep: socios.socio.pessoa.endereco.end_cep,
            rua: socios.socio.pessoa.endereco.end_endereco,
            estado: socios.socio.pessoa.endereco.estado != null ?
              ({ label: socios.socio.pessoa.endereco.estado.name, name: socios.socio.pessoa.endereco.estado.name, value: socios.socio.pessoa.endereco.estado.id, id: socios.socio.pessoa.endereco.estado.id }) :
              ({ label: 'Selecione um Estado', name: '', value: '' }),
            cidade: socios.socio.pessoa.endereco.cidade != null ?
              ({ label: socios.socio.pessoa.endereco.cidade.name, name: socios.socio.pessoa.endereco.cidade.name, value: socios.socio.pessoa.endereco.cidade.id, id: socios.socio.pessoa.endereco.cidade.id }) :
              ({ label: 'Selecione uma Cidade', name: '', value: '' }),
            bairro: socios.socio.pessoa.endereco.bairro != null ?
              [{ label: socios.socio.pessoa.endereco.bairro.name, name: socios.socio.pessoa.endereco.bairro.name, value: socios.socio.pessoa.endereco.bairro.id, id: socios.socio.pessoa.endereco.bairro.id }] :
              [{ label: 'Selecione um Bairro', name: '', value: '' }],
            pais: { label: 'Brazil', name: 'Brazil', value: '27', id: '27' },
            cidades: [{ country_id: 27 }]
          }

          socio['par_id'] = socios.par_id
          socio['par_idparceiro'] = socios.par_idparceiro
          socio['par_idsocio'] = socios.par_idsocio
          socio['pes_id'] = socios.socio.pessoa.pes_id
          socio['nome'] = socios.socio.pessoa.pes_nome
          socio['fis_id'] = socios.socio.pessoa.fisica.fis_id
          socio['documento'] = socios.socio.pessoa.fisica.fis_cpf
          socio['rg'] = socios.socio.pessoa.fisica.fis_registro_geral
          socio['end_id'] = socios.socio.pessoa.endereco.end_id
          socio['endereco'] = endereco

          copySocios.push(socio)
        }
      }

      let copyFinanceiros = { ...state.financeiros }

      if (action.payload.financeiros.length > 0) {

        copyFinanceiros = {
          id_responsavel: action.payload.financeiros[0]['id'],
          id_gerente: action.payload.financeiros[1]['id'],
          responsavel: action.payload.financeiros[0]['responsavel'],
          contatoResponsavel: action.payload.financeiros[0]['contato'],
          whatsappResponsavel: action.payload.financeiros[0]['whatsapp'],
          email: action.payload.financeiros[0]['email'],
          gerente: action.payload.financeiros[1]['responsavel'],
          contatoGerente: action.payload.financeiros[1]['contato'],
          whatsappGerente: action.payload.financeiros[1]['whatsapp']
        }

      }

      const copyFonecedores = []

      if (action.payload.fornecedores.length > 0) {
        for (const fornecedor of action.payload.fornecedores) {
          const forne = {}
          const cobranca = (fornecedor.cobranca == "SERVICO" ? { value: 'SERVICO', label: 'Por serviço' } : { value: 'PESSOA', label: 'Por pessoa' })

          forne['dataInicio'] = fornecedor.tar_data_inicio
            ? new Date(fornecedor.tar_data_inicio)
            : null
          forne['dataFim'] = fornecedor.tar_data_termino
            ? new Date(fornecedor.tar_data_termino)
            : null
          forne['produto'] = fornecedor.produto
          forne['atividade_id'] = fornecedor.atividade_id ?? fornecedor.atividade?.id ?? null
          forne['cobranca'] = cobranca
          forne['valorServico'] = fornecedor.valor_servico
          forne['valorADT'] = fornecedor.valor_adt
          forne['valorCHD'] = fornecedor.valor_chd
          forne['valorIDSO'] = fornecedor.valor_idso
          forne['valorJVM'] = fornecedor.valor_jvm
          forne['valorINF'] = fornecedor.valor_inf
          forne['id'] = fornecedor.tar_id
          forne['regras'] = mapearRegrasTarifario(fornecedor)
          forne['regrasAbertas'] = true

          copyFonecedores.push(forne)

        }

      }

      const copyFinanceiro = { ...state.dadosFinanceiro }

      if (action.payload.parceiro?.financeiro) {
        const dataArray = []
        if (action.payload.parceiro.financeiro.financeiro_data?.length > 0) {
          for (const financeiro of action.payload.parceiro.financeiro.financeiro_data) {
            dataArray.push({ data: financeiro.dia_data, id: financeiro.id })
          }
        }
        copyFinanceiro.dataArray = dataArray

        const copyDias = { ...state.dadosFinanceiro.dias }

        copyDias['segunda'] = action.payload.parceiro.financeiro.segunda
        copyDias['terca'] = action.payload.parceiro.financeiro.terca
        copyDias['quarta'] = action.payload.parceiro.financeiro.quarta
        copyDias['quinta'] = action.payload.parceiro.financeiro.quinta
        copyDias['sexta'] = action.payload.parceiro.financeiro.sexta
        copyDias['sabado'] = action.payload.parceiro.financeiro.sabado
        copyDias['domingo'] = action.payload.parceiro.financeiro.domingo

        copyFinanceiro['id'] = action.payload.parceiro.financeiro.id
        copyFinanceiro.gerarFaturaPorAgente = !!(
          action.payload.parceiro.financeiro?.gerar_fatura_por_agente
        )
        copyFinanceiro.faturaPorAgenteParcial = !!(
          action.payload.parceiro.financeiro?.fatura_por_agente_parcial
        )
        copyFinanceiro.categoriaFinanceiraPagamentoId =
          action.payload.parceiro.financeiro?.categoria_financeira_pagamento_id ?? null
        copyFinanceiro.categoriaFinanceiraRecebimentoId =
          action.payload.parceiro.financeiro?.categoria_financeira_recebimento_id ?? null
        copyFinanceiro['limiteCredito'] = action.payload.parceiro.financeiro.limite_credito ?? copyFinanceiro.limiteCredito
        copyFinanceiro['metaReservasMes'] = action.payload.parceiro.meta?.meta_reservas_mes ?? ''
        copyFinanceiro['vencimento'] = action.payload.parceiro.financeiro.vencimento ?? copyFinanceiro.vencimento
        // Evita race: estado inicial limitesPorSegmento=true desmarcava FATURADO
        // antes de inferir que o parceiro tem limite próprio.
        const limCredito = Number(copyFinanceiro.limiteCredito) || 0
        copyFinanceiro.limitesPorSegmento = limCredito <= 0

        copyFinanceiro.dias = copyDias
      }
      let i = 0
      const pagamentosIds = []

      const selecionados = action.payload.parceiro?.pagamentos_formas?.map((row, index) => {
        return action.payload.pagmentoForma.filter((item) => item.pag_id === row.pag_id)
      }).flat()

      if (Array.isArray(selecionados)) {

        selecionados?.map((row, index) => {
          console.log(row, 'row')
          const payload = row.pag_id

          pagamentosIds.push(payload)

          i++
        })
        copyFinanceiro.pagamentosIds = pagamentosIds

        const tiposIds = [...new Set(
          selecionados
            .map((row) => row.pag_idtipo ?? row.tipo?.id)
            .filter((id) => id != null && id !== '')
        )]
        copyFinanceiro.pagamentosTiposIds = tiposIds
      }

      return {
        ...state,
        dadosContatos: copyContatos,
        parceiro: action.payload.parceiro,
        enderecoCobranca: action.payload.enderecoCobranca,
        listSocios: copySocios,
        financeiros: copyFinanceiros,
        tarifarios: copyFonecedores,
        dadosFinanceiro: copyFinanceiro
      }
    }
    ///editei aqui
    case 'PARCEIRO_PADRAO_FETCHED':
      return { ...state, parceiro: action.payload.parceiro, enderecoPadrao: action.payload.enderecoPadrao }

    case 'PARCEIROS_FETCHED':
      return { ...state, parceiro: action.payload }

    case 'PERMISSAO_FETCHED':
      return { ...state, tipos: action.payload }

    case 'CLIENTE_FETCHED':
      return { ...state, cliente: action.payload }

    case 'GET_PARCEIRO':
      return { ...state, editarParceiro: action.payload }

    case 'SET_DADOS_EMPRESA':
      // console.log('SET_DADOS_EMPRESA', action)
      const empresa = { ...state.dadosEmpresa }
      const campoEmpresa = action.payload.campo.split('.')

      if (campoEmpresa.length > 1) {
        const copyCampo = { ...empresa[campoEmpresa[0]] }
        copyCampo[campoEmpresa[1]] = action.payload.value
        empresa[campoEmpresa[0]] = copyCampo
      } else {
        empresa[campoEmpresa[0]] = action.payload.value
      }

      return { ...state, dadosEmpresa: empresa }

    case 'SET_CHECKBOX_EMPRESA':
      // console.log('SET_CHECKBOX_EMPRESA', action)
      const dados = { ...state.dadosParceiro }
      dados[action.payload.campo] = action.payload.value

      return { ...state, dadosParceiro: dados }

    case 'SET_ENDERECO_SIM_EMPRESA': {
      // console.log('SET_CHECKBOX_EMPRESA', action)
      const dados = { ...state.dadosParceiro }
      dados[action.payload.campo] = action.payload.value

      return { ...state, dadosParceiro: dados }
    }
    case 'SET_ENDERECO_NAO_EMPRESA': {
      // console.log('SET_CHECKBOX_EMPRESA', action)
      const dados = { ...state.dadosParceiro }
      dados[action.payload.campo] = action.payload.value

      return { ...state, dadosParceiro: dados }
    }
    case 'SET_DADOS_BANCARIOS':
      const banco = { ...state.dadosBancarios }
      banco[action.payload.campo] = action.payload.value
      return { ...state, dadosBancarios: banco }

    case 'SET_SOCIOS':
      return { ...state, socios: action.payload }

    case 'SET_AGENTES':
      return { ...state, agentes: action.payload }

    case 'SET_USUARIOS':
      return { ...state, usuarios: action.payload }

    case 'SET_DADOS_USUARIO':
      const usuario = { ...state.dadosUsuario }
      const campoUsuario = action.payload.campo.split('.')

      if (campoUsuario.length > 1) {
        const copyCampo = { ...usuario[campoUsuario[0]] }
        copyCampo[campoUsuario[1]] = action.payload.value
        usuario[campoUsuario[0]] = copyCampo
      } else {
        usuario[campoUsuario[0]] = action.payload.value
      }

      return { ...state, dadosUsuario: usuario }

    case 'SET_DADOS_USUARIO_CONHECIMENTOS':
      const conhecimentos = { ...state.dadosUsuario }
      const campoConhecimentos = action.payload.campo.split('.')

      if (campoConhecimentos.length > 1) {
        const copyCampo = { ...conhecimentos[campoConhecimentos[0]] }
        copyCampo[campoConhecimentos[1]] = action.payload.value
        conhecimentos[campoConhecimentos[0]] = copyCampo
      } else {
        conhecimentos[campoConhecimentos[0]] = action.payload.value
      }
      return { ...state, dadosUsuario: conhecimentos }

    case 'SET_DADOS_USUARIO_IDIOMAS':
      const idiomas = { ...state.dadosUsuario }
      const campoIdiomas = action.payload.campo.split('.')

      if (campoIdiomas.length > 1) {
        const copyCampo = { ...idiomas[campoIdiomas[0]] }
        copyCampo[campoIdiomas[1]] = action.payload.value
        idiomas[campoIdiomas[0]] = copyCampo
      } else {
        idiomas[campoIdiomas[0]] = action.payload.value
      }
      return { ...state, dadosUsuario: idiomas }

    case 'SET_DADOS_USUARIO_ROTEIROS':
      const roteiros = { ...state.dadosUsuario }
      const campoRoteiros = action.payload.campo.split('.')

      if (campoRoteiros.length > 1) {
        const copyCampo = { ...roteiros[campoRoteiros[0]] }
        copyCampo[campoRoteiros[1]] = action.payload.value
        roteiros[campoRoteiros[0]] = copyCampo
      } else {
        roteiros[campoRoteiros[0]] = action.payload.value
      }
      return { ...state, dadosUsuario: roteiros }

    case 'SET_DADOS_USUARIO_HABILIDADES':
      const habilidades = { ...state.dadosUsuario }
      const campoHabilidades = action.payload.campo.split('.')

      if (campoHabilidades.length > 1) {
        const copyCampo = { ...habilidades[campoHabilidades[0]] }
        copyCampo[campoHabilidades[1]] = action.payload.value
        habilidades[campoHabilidades[0]] = copyCampo
      } else {
        habilidades[campoHabilidades[0]] = action.payload.value
      }
      return { ...state, dadosUsuario: habilidades }

    case 'SET_REFERENCIAS_BANCARIAS':
      return { ...state, referenciasBancarias: action.payload }

    case 'SET_REFERENCIAS_COMERCIAIS':
      return { ...state, referenciasComerciais: action.payload }

    case 'PARCEIRO_ESTADOS_FETCH':
      const estados = { ...state.mundo, estados: action.payload }
      return { ...state, mundo: estados }

    case 'PARCEIRO_CIDADES_FETCH':
      const cidades = { ...state.mundo, cidades: action.payload }
      return { ...state, mundo: cidades }

    case 'PARCEIRO_BAIRROS_FETCH':
      const bairros = { ...state.mundo, bairros: action.payload }
      return { ...state, mundo: bairros }

    case 'PARCEIRO_ESTADOS_COBRANCA_FETCH':
      const estadosCobranca = { ...state.mundo, estadosCobranca: action.payload }
      return { ...state, mundo: estadosCobranca }

    case 'PARCEIRO_CIDADES_COBRANCA_FETCH':
      const cidadesCobranca = { ...state.mundo, cidadesCobranca: action.payload }
      return { ...state, mundo: cidadesCobranca }

    case 'PARCEIRO_BAIRROS_COBRANCA_FETCH':
      const bairrosCobranca = { ...state.mundo, bairrosCobranca: action.payload }
      return { ...state, mundo: bairrosCobranca }

    case 'PARCEIRO_ERRORS':
      return { ...state, errors: action.payload }
    case 'REFS_BANCARIAS':
      return { ...state, referenciasBancarias: action.payload }
    case 'REF_BANCARIA':
      return { ...state, referenciaBancaria: action.payload }
    case 'REFS_COMERCIAIS':
      return { ...state, referenciasComerciais: action.payload }
    case 'REF_COMERCIAL':
      return { ...state, referenciaComercial: action.payload }
    case 'PARCEIRO_TARIFARIOS':
      return { ...state, parceiroTarifarios: action.payload }
    case 'PARCEIRO_TARIFARIO':
      return { ...state, parceiroTarifario: action.payload }
    case 'PARCEIRO_TARIFARIO_EDITAR': {
      const copyInput = { ...state.parceiroTarifarioInput }

      const servico = action.payload.atividade
        ? { value: action.payload.atividade.id, label: action.payload.atividade.nome }
        : action.payload.tarifario?.tipo
          ? { value: action.payload.tarifario.tipo.tip_id, label: action.payload.tarifario.tipo.tip_nome }
          : { value: '', label: '' }

      const nomeFornecedor = action.payload?.parceiro?.pessoa?.pes_nome || ''
      const nomeProduto = action.payload?.tarifario?.produto || ''
      const labelProduto = nomeProduto
        ? (nomeFornecedor ? `${nomeFornecedor} - ${nomeProduto}` : nomeProduto)
        : nomeFornecedor

      copyInput['parceiro'] = ({
        value: action.payload?.tarifario?.tar_id || action.payload?.parceiro_tarifario_id,
        label: labelProduto || 'Selecione o produto'
      })
      copyInput['servico'] = (servico)

      return { ...state, parceiroTarifario: action.payload, parceiroTarifarioInput: copyInput }
    }
    case 'PARCEIRO_CHANGE_INPUT': {
      const copyInput = { ...state.parceiroTarifarioInput }

      copyInput[action.input] = action.payload

      return { ...state, parceiroTarifarioInput: copyInput }
    }
    case 'PARCEIRO_LIMPAR_INPUT': {
      const copyInput = {
        servico: { value: 0, label: 'Selecione a atividade' },
        parceiro: { value: 0, label: 'Selecione o produto' }
      }

      return { ...state, parceiroTarifarioInput: copyInput }
    }
    case 'SET_PARCEIRO_ID':
      return { ...state, parceiroId: action.payload }

    case 'USU_PARCEIROS':
      return { ...state, usuariosParceiros: action.payload }
    case 'USU_PARCEIRO':
      return { ...state, usuarioParceiro: action.payload }

    case 'PARCEIRO_RESET':
      return {
        ...state,
        dadosSocios: INITIAL_STATE.dadosSocios,
        dadosParceiro: INITIAL_STATE.dadosParceiro,
        dadosEmpresa: INITIAL_STATE.dadosEmpresa,
        dadosContatos: INITIAL_STATE.dadosContatos,
        dadosDocumentos: INITIAL_STATE.dadosDocumentos,
        enderecoCheckbox: INITIAL_STATE.enderecoCheckbox,
        dadosBancarios: INITIAL_STATE.dadosBancarios,
        socios: INITIAL_STATE.socios,
        dadosUsuario: INITIAL_STATE.dadosUsuario,
        referenciasComerciais: INITIAL_STATE.referenciasComerciais,
        referenciasComerciais: INITIAL_STATE.referenciasComerciais,
        dadosPromotor: INITIAL_STATE.dadosPromotor,
        dadosHotel: INITIAL_STATE.dadosHotel,
        dadosAgenciaTurismo: INITIAL_STATE.dadosAgenciaTurismo,
        dadosOperadoraTurismo: INITIAL_STATE.dadosOperadoraTurismo,
        dadosFinanceiros: INITIAL_STATE.dadosFinanceiros,
        dadosFinanceiro: INITIAL_STATE.dadosFinanceiro,
        tarifarios: INITIAL_STATE.tarifarios
      }

    case 'SET_DADOS_PESSOAIS_PROMOTOR':
      const dadosPessoais = { ...state.dadosPromotor }
      const campoDadosPessoais = action.payload.campo.split('.')

      if (campoDadosPessoais.length > 1) {
        const copyCampo = { ...dadosPessoais[campoDadosPessoais[0]] }
        copyCampo[campoDadosPessoais[1]] = action.payload.value
        dadosPessoais[campoDadosPessoais[0]] = copyCampo
      } else {
        dadosPessoais[campoDadosPessoais[0]] = action.payload.value
      }

      return { ...state, dadosPromotor: dadosPessoais }

    case 'SET_DADOS_BANCARIOS_PROMOTOR':
      const dadosBancarios = { ...state.dadosPromotor }
      const campoDadosBancarios = action.payload.campo.split('.')

      if (campoDadosBancarios.length > 1) {
        const copyCampo = { ...dadosBancarios[campoDadosBancarios[0]] }
        copyCampo[campoDadosBancarios[1]] = action.payload.value
        dadosBancarios[campoDadosBancarios[0]] = copyCampo
      } else {
        dadosBancarios[campoDadosBancarios[0]] = action.payload.value
      }

      return { ...state, dadosPromotor: dadosBancarios }

    case 'SET_DADOS_EMPRESA_HOTEL':
      const empresaHotel = { ...state.dadosHotel }
      const campoEmpresaHotel = action.payload.campo.split('.')

      if (campoEmpresaHotel.length > 1) {
        const copyCampo = { ...empresaHotel[campoEmpresaHotel[0]] }
        copyCampo[campoEmpresaHotel[1]] = action.payload.value
        empresaHotel[campoEmpresaHotel[0]] = copyCampo
      } else {
        empresaHotel[campoEmpresaHotel[0]] = action.payload.value
      }

      return { ...state, dadosHotel: empresaHotel }

    case 'SET_DADOS_USUARIO_HOTEL':
      const usuarioHotel = { ...state.dadosHotel }
      const campoUsuarioHotel = action.payload.campo.split('.')

      if (campoUsuarioHotel.length > 1) {
        const copyCampo = { ...usuarioHotel[campoUsuarioHotel[0]] }
        copyCampo[campoUsuarioHotel[1]] = action.payload.value
        usuarioHotel[campoUsuarioHotel[0]] = copyCampo
      } else {
        usuarioHotel[campoUsuarioHotel[0]] = action.payload.value
      }

      return { ...state, dadosHotel: usuarioHotel }

    case 'SET_DADOS_FINANCEIROS':
      const copyFinanceiros = { ...state.dadosFinanceiros }
      const campoFinanceiro = action.payload.campo.split('.')

      if (campoFinanceiro.length > 1) {
        const copyInput = { ...copyFinanceiros[campoFinanceiro[0]] }
        copyInput[campoFinanceiro[1]] = action.payload.value
        copyFinanceiros[campoFinanceiro[0]] = copyInput
      } else {
        copyFinanceiros[campoFinanceiro[0]] = action.payload.value
      }

      return { ...state, dadosFinanceiros: copyFinanceiros }

    case 'SET_DADOS_CONTATOS':
      const copyContatos = { ...state.dadosContatos }
      const campoContatos = action.payload.campo.split('.')

      if (campoContatos.length > 1) {
        const copyInput = { ...copyContatos[campoContatos[0]] }
        copyInput[campoContatos[1]] = action.payload.value
        copyContatos[campoContatos[0]] = copyInput
      } else {
        copyContatos[campoContatos[0]] = action.payload.value
      }

      return { ...state, dadosContatos: copyContatos }
    case 'SET_DADOS_SOCIOS': {
      const copySocios = [...state.dadosSocios]
      const newSocio = { ...copySocios[action.index] }
      console.log(newSocio, action.index, 'socio  testehybvji ')
      newSocio[action.name] = action.payload
      copySocios[action.index] = newSocio
      return { ...state, dadosSocios: copySocios }
    }
    case 'SET_DADOS_DOCUMENTOS':
      const copyDocumentos = { ...state.dadosDocumentos }
      const campoDocumentos = action.payload.campo.split('.')

      if (campoDocumentos.length > 1) {
        const copyInput = { ...copyDocumentos[campoDocumentos[0]] }
        copyInput[campoDocumentos[1]] = action.payload.value
        copyDocumentos[campoDocumentos[0]] = copyInput
      } else {
        copyDocumentos[campoDocumentos[0]] = action.payload.value
      }

      return { ...state, dadosDocumentos: copyDocumentos }

    case 'SET_DADOS_TARIFARIOS': {
      var copyTarifarios = [...state.tarifarios]
      var newFonte = { ...copyTarifarios[action.index] }

      newFonte[action.name] = action.payload
      copyTarifarios[action.index] = newFonte
      return { ...state, tarifarios: copyTarifarios }
    }

    case 'SET_DADOS_TARIFARIOS_VALORES': {
      var copyTarifarios = [...state.tarifarios]
      var newFonte = { ...copyTarifarios[action.index] }

      if (isNaN(action.payload)) {
        newFonte[action.name] = Number(action.payload.replace(',', '.'))
      } else {
        newFonte[action.name] = Number(action.payload)
      }

      copyTarifarios[action.index] = newFonte
      return { ...state, tarifarios: copyTarifarios }
    }

    case 'SET_DADOS_FINANCEIROS_DATA': {
      const copayData = [...state.dadosFinanceiro.dataArray]
      const newFinanceiro = { ...copayData[action.index] }

      const copyDadosFinanceiro = { ...state.dadosFinanceiro }

      newFinanceiro.data = action.payload

      copayData[action.index] = newFinanceiro
      copyDadosFinanceiro.dataArray = copayData

      return { ...state, dadosFinanceiro: copyDadosFinanceiro }
    }

    case 'ADD_PARCEIROS_FORNECEDORES_PRECO_ROW': {
      let precosCopy = [...state.tarifarios]
      precosCopy = action.payload
      return { ...state, tarifarios: precosCopy }
    }

    case 'REMOVER_PARCEIROS_FORNECEDORES_PRECO_ROW':
      var removeTarifario = state.tarifarios.filter((pagamento, index) => index !== action.index)
      return { ...state, tarifarios: removeTarifario }

    case 'SET_DADOS_TARIFARIO_REGRA': {
      const copyTarifarios = [...state.tarifarios]
      const tarifario = { ...copyTarifarios[action.index] }
      const regras = Array.isArray(tarifario.regras) ? [...tarifario.regras] : []
      const regra = { ...(regras[action.regraIndex] || regraPadraoVazia()) }
      regra[action.name] = action.payload
      regras[action.regraIndex] = regra
      tarifario.regras = regras
      copyTarifarios[action.index] = tarifario
      return { ...state, tarifarios: copyTarifarios }
    }

    case 'SET_DADOS_TARIFARIO_REGRA_DIA': {
      const copyTarifarios = [...state.tarifarios]
      const tarifario = { ...copyTarifarios[action.index] }
      const regras = Array.isArray(tarifario.regras) ? [...tarifario.regras] : []
      const regra = { ...(regras[action.regraIndex] || regraPadraoVazia()) }
      regra.dias = { ...(regra.dias || {}), [action.dia]: action.payload ? 1 : 0 }
      regras[action.regraIndex] = regra
      tarifario.regras = regras
      copyTarifarios[action.index] = tarifario
      return { ...state, tarifarios: copyTarifarios }
    }

    case 'SET_DADOS_TARIFARIO_REGRA_VALOR': {
      const copyTarifarios = [...state.tarifarios]
      const tarifario = { ...copyTarifarios[action.index] }
      const regras = Array.isArray(tarifario.regras) ? [...tarifario.regras] : []
      const regra = { ...(regras[action.regraIndex] || regraPadraoVazia()) }
      const raw = action.payload
      if (isNaN(raw)) {
        regra[action.name] = Number(String(raw).replace(',', '.'))
      } else {
        regra[action.name] = Number(raw)
      }
      regras[action.regraIndex] = regra
      tarifario.regras = regras
      copyTarifarios[action.index] = tarifario
      return { ...state, tarifarios: copyTarifarios }
    }

    case 'ADD_TARIFARIO_REGRA': {
      const copyTarifarios = [...state.tarifarios]
      const tarifario = { ...copyTarifarios[action.index] }
      const regras = Array.isArray(tarifario.regras) ? [...tarifario.regras] : []
      regras.push({
        ...regraPadraoVazia(),
        nome: action.nome || ''
      })
      tarifario.regras = regras
      tarifario.regrasAbertas = true
      copyTarifarios[action.index] = tarifario
      return { ...state, tarifarios: copyTarifarios }
    }

    case 'REMOVER_TARIFARIO_REGRA': {
      const copyTarifarios = [...state.tarifarios]
      const tarifario = { ...copyTarifarios[action.index] }
      const regras = (Array.isArray(tarifario.regras) ? tarifario.regras : [])
        .filter((_, i) => i !== action.regraIndex)
      tarifario.regras = regras.length > 0 ? regras : [regraPadraoVazia()]
      copyTarifarios[action.index] = tarifario
      return { ...state, tarifarios: copyTarifarios }
    }

    case 'TOGGLE_TARIFARIO_REGRAS': {
      const copyTarifarios = [...state.tarifarios]
      const tarifario = { ...copyTarifarios[action.index] }
      tarifario.regrasAbertas = !tarifario.regrasAbertas
      copyTarifarios[action.index] = tarifario
      return { ...state, tarifarios: copyTarifarios }
    }

    case 'ADD_PARCEIROS_VENCIMENTO_DATA_ROW': {
      const vencimentoCopy = { ...state.dadosFinanceiro }
      vencimentoCopy.dataArray = action.payload
      return { ...state, dadosFinanceiro: vencimentoCopy }
    }

    case 'REMOVER_PARCEIROS_FINANCEIRO_DATA_ROW': {
      const vencimentoCopy = { ...state.dadosFinanceiro }
      vencimentoCopy.dataArray = action.payload
      return { ...state, dadosFinanceiro: vencimentoCopy }

    }

    case 'ADD_PARCEIROS_SOCIOS_ROW': {
      let sciosCopy = [...state.dadosSocios]
      sciosCopy = action.payload
      return { ...state, dadosSocios: sciosCopy }
    }

    case 'REMOVER_PARCEIROS_SOCIOS_ROW': {
      const removeSocios = state.dadosSocios.filter((pagamento, index) => index !== action.index)
      return { ...state, dadosSocios: removeSocios }
    }
    case 'SET_DADOS_EMPRESA_AGENCIA_TURISMO':
      const empresaAgenciaTurismo = { ...state.dadosAgenciaTurismo }
      const campoEmpresaAgenciaTurismo = action.payload.campo.split('.')

      if (campoEmpresaAgenciaTurismo.length > 1) {
        const copyCampo = { ...empresaAgenciaTurismo[campoEmpresaAgenciaTurismo[0]] }
        copyCampo[campoEmpresaAgenciaTurismo[1]] = action.payload.value
        empresaAgenciaTurismo[campoEmpresaAgenciaTurismo[0]] = copyCampo
      } else {
        empresaAgenciaTurismo[campoEmpresaAgenciaTurismo[0]] = action.payload.value
      }

      return { ...state, dadosAgenciaTurismo: empresaAgenciaTurismo }

    case 'SET_DADOS_BANCARIOS_AGENCIA_TURISMO':
      const bancariosAgenciaTurismo = { ...state.dadosAgenciaTurismo }
      const campoBancariosAgenciaTurismo = action.payload.campo.split('.')

      if (campoBancariosAgenciaTurismo.length > 1) {
        const copyCampo = { ...bancariosAgenciaTurismo[campoBancariosAgenciaTurismo[0]] }
        copyCampo[campoBancariosAgenciaTurismo[1]] = action.payload.value
        bancariosAgenciaTurismo[campoBancariosAgenciaTurismo[0]] = copyCampo
      } else {
        bancariosAgenciaTurismo[campoBancariosAgenciaTurismo[0]] = action.payload.value
      }

      return { ...state, dadosAgenciaTurismo: bancariosAgenciaTurismo }
    case 'SET_DADOS_FINANCEIRO':

      const copyDadosFinanceiro = { ...state.dadosFinanceiro }
      const campoDadosFinanceiro = action.campo
      copyDadosFinanceiro[campoDadosFinanceiro] = action.value

      return { ...state, dadosFinanceiro: copyDadosFinanceiro }

    case 'SET_DADOS_USUARIO_AGENCIA_TURISMO':
      const usuarioAgenciaTurismo = { ...state.dadosAgenciaTurismo }
      const campoUsuarioAgenciaTurismo = action.payload.campo.split('.')

      if (campoUsuarioAgenciaTurismo.length > 1) {
        const copyCampo = { ...usuarioAgenciaTurismo[campoUsuarioAgenciaTurismo[0]] }
        copyCampo[campoUsuarioAgenciaTurismo[1]] = action.payload.value
        usuarioAgenciaTurismo[campoUsuarioAgenciaTurismo[0]] = copyCampo
      } else {
        usuarioAgenciaTurismo[campoUsuarioAgenciaTurismo[0]] = action.payload.value
      }

      return { ...state, dadosAgenciaTurismo: usuarioAgenciaTurismo }

    case 'SET_DADOS_EMPRESA_OPERADORA_TURISMO':
      const empresaOperadoraTurismo = { ...state.dadosOperadoraTurismo }
      const campoEmpresaOperadoraTurismo = action.payload.campo.split('.')

      if (campoEmpresaOperadoraTurismo.length > 1) {
        const copyCampo = { ...empresaOperadoraTurismo[campoEmpresaOperadoraTurismo[0]] }
        copyCampo[campoEmpresaOperadoraTurismo[1]] = action.payload.value
        empresaOperadoraTurismo[campoEmpresaOperadoraTurismo[0]] = copyCampo
      } else {
        empresaOperadoraTurismo[campoEmpresaOperadoraTurismo[0]] = action.payload.value
      }

      return { ...state, dadosOperadoraTurismo: empresaOperadoraTurismo }

    case 'SET_DADOS_BANCARIOS_OPERADORA_TURISMO':
      const bancariosOperadoraTurismo = { ...state.dadosOperadoraTurismo }
      const campoBancariosOperadoraTurismo = action.payload.campo.split('.')

      if (campoBancariosOperadoraTurismo.length > 1) {
        const copyCampo = { ...bancariosOperadoraTurismo[campoBancariosOperadoraTurismo[0]] }
        copyCampo[campoBancariosOperadoraTurismo[1]] = action.payload.value
        bancariosOperadoraTurismo[campoBancariosOperadoraTurismo[0]] = copyCampo
      } else {
        bancariosOperadoraTurismo[campoBancariosOperadoraTurismo[0]] = action.payload.value
      }

      return { ...state, dadosOperadoraTurismo: bancariosOperadoraTurismo }

    case 'SET_DADOS_USUARIO_OPERADORA_TURISMO':
      const usuarioOperadoraTurismo = { ...state.dadosOperadoraTurismo }
      const campoUsuarioOperadoraTurismo = action.payload.campo.split('.')

      if (campoUsuarioOperadoraTurismo.length > 1) {
        const copyCampo = { ...usuarioOperadoraTurismo[campoUsuarioOperadoraTurismo[0]] }
        copyCampo[campoUsuarioOperadoraTurismo[1]] = action.payload.value
        usuarioOperadoraTurismo[campoUsuarioOperadoraTurismo[0]] = copyCampo
      } else {
        usuarioOperadoraTurismo[campoUsuarioOperadoraTurismo[0]] = action.payload.value
      }

      return { ...state, dadosOperadoraTurismo: usuarioOperadoraTurismo }

    default:
      return state
    // GUIA
    case 'FEATCH_GUIAS_SELECT_OPTIONS':
      let guiasSelectOptionsCopy = [...action.payload]
      let optionVazia = { value: '', label: "Remover Guia" }

      guiasSelectOptionsCopy.unshift(optionVazia)

      return { ...state, guiasSelectOptions: guiasSelectOptionsCopy }
    case 'FEATCH_GUIAS_MAPA_SELECT_OPTIONS':
      return { ...state, guiasSelectOptions: action.payload }
    case 'FEATCH_GUIAS_TOUR_DATE_SELECT_OPTIONS':
      return { ...state, guiasTourDateSelectOptions: action.payload }
    case 'FEATCH_GUIAS_BLOQUEIOS_DATAS':
      return { ...state, guiasBloqueiosDatas: action.payload || {} }
    case 'FEATCH_PASSEIOS_GUIA_DATE_SELECT_OPTIONS':
      return { ...state, passeiosGuiaDateSelectOptions: action.payload }
    // FRONECEDOR
    case 'FEATCH_FORNECORES_SELECT_OPTIONS':
      return { ...state, fornecedoresSelectOptions: action.payload }
    case 'PARCEIRO_PATH_CHANGER':
      return { ...state, path: action.payload }
    // CLIENTES
    case 'FETCHED_CLIENTES_SELECT_DEFAULT_OPTIONS':
      return { ...state, clienteDefaultOptions: action.payload }

    case 'SET_DADOS_FINANCEIROS_DIAS': {
      const copyDia = { ...state.dadosFinanceiro.dias }
      const copaFinanceiro = { ...state.dadosFinanceiro }

      copyDia[action.name] = action.payload
      copaFinanceiro.dias = copyDia

      return { ...state, dadosFinanceiro: copaFinanceiro }
    }

    case 'SET_PARCEIRO_FINANCEIRO_DISABLE_DATAS': {
      let copyDisable = false
      const copydados = { ...state.dadosFinanceiro }
      const ultimo = copydados.dataArray.slice(-1)
      const indexUltimo = copydados.dataArray.indexOf(ultimo)

      copydados.dataArray?.map((data, index) => {
        if (data.data != null && data.data != '') {
          copyDisable = true
          return
        }

        if (index === indexUltimo) {
          copyDisable = false
        }
      })

      return { ...state, financeiroDisableDia: copyDisable }
    }

    case 'SET_PARCEIRO_FINANCEIRO_DISABLE_DIAS': {
      let copyDisable = false
      const copydados = { ...state.dadosFinanceiro }

      console.log(copydados.dias, 'SET_PARCEIRO_FINANCEIRO_DISABLE_DIAS')

      copydados.dias?.map((dias, index) => {
        if (dias) {
          copyDisable = true
          return
        }

        if (index === copydados.dias.lenght - 1) {
          copyDisable = false
        }
      })

      return { ...state, financeiroDisableData: copyDisable }
    }

    case 'SET_PARCEIRO_FINANCEIRO_DISABLE_DIAS_EDICAO': {
      let copyDisable = false
      const copydados = { ...state.dadosFinanceiro }

      if (copydados.dias.segunda == true || copydados.dias.terca == true || copydados.dias.quarta == true || copydados.dias.quinta == true ||
        copydados.dias.sexta == true || copydados.dias.sabado == true || copydados.dias.domingo == true) {
        copyDisable = true
      }

      if (copydados.dias.segunda == false && copydados.dias.terca == false && copydados.dias.quarta == false && copydados.dias.quinta == false &&
        copydados.dias.sexta == false && copydados.dias.sabado == false && copydados.dias.domingo == false) {
        copyDisable = false
      }

      return { ...state, financeiroDisableData: copyDisable }
    }
  }
}